import React from "react";
import { Card, Button, Typography, Row, notification } from "antd";
import axios from "axios";
import { DownloadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const AdminAnalyse = () => {
  // Function to handle export of graduated students
  const handleExportGraduates = () => {
    axios({
      url: "/students/export_graduated_students/",
      method: "GET",
      responseType: "blob", // Important for file download
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "graduated_students.csv"); // Name of the downloaded file
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      })
      .catch(() => {
        notification.error({
          message: "Export Failed",
          description: "Failed to export graduates list. Please try again.",
        });
      });
  };

  // Function to handle export of fifth-year students
  const handleExportFifthYear = () => {
    axios({
      url: "/students/export_fifth_year_students/",
      method: "GET",
      responseType: "blob", // Important for file download
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "fifth_year_students.csv"); // Name of the downloaded file
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      })
      .catch(() => {
        notification.error({
          message: "Export Failed",
          description: "Failed to export fifth-year list. Please try again.",
        });
      });
  };

  return (
    <Card>
      <Row justify="center">
        <Title level={2}>Student Exports</Title>
      </Row>
      <Row justify="center" style={{ marginTop: "20px" }}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          size="large"
          onClick={handleExportGraduates}
          style={{ marginRight: "20px" }}
        >
          Export Graduates
        </Button>
        <Button type="primary" icon={<DownloadOutlined />} size="large" onClick={handleExportFifthYear}>
          Export Fifth-Year Students
        </Button>
      </Row>
    </Card>
  );
};

export default AdminAnalyse;
